<div style="display: table; width: 100%">
<div #toolbar class="card-toolbar" style="display: inline-flex; width: 100%;">

	<div style="display: flex; width:33.3%; text-align:left;">
		 <!-- <button mat-icon-button (click)="menu.toggle($event, toolbar)">
			<mat-icon>menu</mat-icon>
		  </button> -->
	</div>

    <div style="width:33.3%; text-align:center;">
        <div [hidden]="!hasAgencySelection">
            <div style="display: inline-block;font-size: 11pt; padding-top:8px; font-weight:normal">Agency:</div>
            <div style="padding-left: 10px;padding-top:5px;display: inline-block;">
            <dw-dropdown [dataSource]="agenciesList"
                         [selectedItem]="selectedAgency"
                         [controlWidth]="'210px'"
                         (itemSelected)="selectedAgency = $event; onAgencyChange($event)">
            </dw-dropdown>
            </div>
        </div>
        <div class="header-text-styles" style="padding-top:10px;" *ngIf="!hasAgencySelection">
            Agency: {{agencyName}}
        </div>
    </div>

    <div [hidden]="!hastimeFrameSelection" style="width: 33.3%; text-align:right;">
        <div class="header-text-styles">Timeframe:</div>
        <div style="padding-left: 10px;padding-top:5px;display: inline-block;">
            <dw-dropdown [dataSource]="timeframeList"
                         [selectedItem]="selectedTimeframe"
                         [controlWidth]="'180px'"
                         (itemSelected)="selectedTimeframe = $event; onTimeframeChange($event)">
            </dw-dropdown>
        </div>
    </div>
</div>

  <p-overlayPanel #menu [style]="{'left': '125px', 'top': '125px'}">
	  	<div style="width: 18rem; height: auto; display: inline-grid;">
			<span class="widget-title">Display Charts:</span>
			<div *ngFor="let item of this.totalMetricCardArr" class="widget-container">
				<p-checkbox name="metriccardsselection" [value]="item.id" [label]="item.title"
							[(ngModel)]="selectedMetricCards"></p-checkbox>
			</div>
			<div *ngFor="let item of this.totalChartArr" class="widget-container">
				<p-checkbox name="chartselection" [value]="item.id" [label]="item.title"
							[(ngModel)]="selectedCharts"></p-checkbox>
			</div>
		</div>
		<div style="width: auto; height: auto; display: block; margin-top: 1rem; margin-bottom: 3.5rem;">
			<button mat-stroked-button (click)="menu.toggle($event, toolbar); homeResetHandler($event)"
					class="widget-command-buttons"
					style="float: left">Reset</button>
			<button mat-stroked-button (click)="menu.toggle($event, toolbar); homeApplyHandler($event)" color="primary"
					class="widget-command-buttons"
					style="float: right; margin-left: 1rem;">Apply</button>
			<button mat-stroked-button (click)="menu.toggle($event, toolbar); homeCancelHandler($event)"
					class="widget-command-buttons"
					style="float: right">Cancel</button>
		</div>
  </p-overlayPanel>


</div>

<div class="container-div">
	<!-- do we have metric cards? -->
	<div class="metric-card-container">
		<div *ngFor="let item of this.metricCardArr" style="display: inline-block;">
			<metric-card-component

					[ngStyle]="{'width':'270px'}"
			[selectedCard]="item"></metric-card-component>
	   	</div>
	</div>

  	<!-- regular graphs and charts -->
	<!--<app-gantt-chart-control [rows]="rows"></app-gantt-chart-control> -->

	<div class="card-container">
		<!--fxLayout="row wrap"	fxLayoutAlign="space-around center"
		 fxLayoutGap="4px grid">
		-->
		<div  *ngFor="let chart of this.chartArr"
			  style="display: inline-block; margin: 6px;border: none; box-shadow:none;">
			<!--
			 [ngClass]="{'inline-block' : chart.type === 'pie' || chart.type === 'bar'}">
				-->
				<!-- spacer to even out the horizontal channels -->
				<div *ngIf="chart.type === 'milestone-calendar' || chart.type === 'gantt-control'"
					 style="padding-top: 1px;" >
				</div>

			<card-component class="mat-elevation-z2" [refreshEvent]="refreshEvent"
                            [agencyId]="this.selectedAgency"
							[selectedChart]="chart" >

			</card-component>
		</div>

	</div>
</div>
